import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';

import CtaLink from 'components/essentials/Cta/CtaLink';
import ShopPageCategoryPanel from './ShopPageCategoryPanel';
import mobileLivingRoomData from './mobileLivingRoomData';
import TwoColumns from './TwoColumns';
import getSubcategories from './getSubcategories';
import ShopPageList from './ShopPageList';

const DiningRoomPanel = () => (
  <ShopPageCategoryPanel
    name="Dining Room"
    path="/dining-room-furniture"
    inspirationPath="/customer-photos?room=Dining Room"
    image="https://joybird2.imgix.net/static-v1/shop/End-Of-Summer-Dining-Room-2-T3-172.jpg"
    className="[grid-area:ShopPageCategoryPanelDiningRoom]"
  />
);

const DecorPanel = () => (
  <ShopPageCategoryPanel
    name="Decor"
    path="/decoration-accessories"
    inspirationPath="/customer-photos"
    className="[grid-area:ShopPageCategoryPanelDecor]"
  />
);

const BedroomPanel = () => (
  <ShopPageCategoryPanel
    name="Bedroom"
    path="/bedroom"
    inspirationPath="/customer-photos?room=Bedroom"
    image="https://joybird2.imgix.net/static-v1/shop/Hughes-Bed-Key-Largo-Zenith-Teal-T2-1551.jpg"
    className="[grid-area:ShopPageCategoryPanelBedroom]"
  />
);

const OutdoorPanel = () => (
  <ShopPageCategoryPanel
    name="Outdoor"
    path="/outdoor-furniture"
    inspirationPath="/customer-photos?room=Outdoor Room"
    image="https://joybird2.imgix.net/static-v1/shop/Bondi-Outdoor-Collection-T4-340.jpg"
    className="[grid-area:ShopPageCategoryPanelOutdoor]"
  />
);

const LivingRoomPanelMobile = () => (
  <ShopPageCategoryPanel
    name="Living Room"
    path="/living-room-furniture"
    inspirationPath="/customer-photos?room=Living Room"
    subcategories={mobileLivingRoomData.subcategory}
  />
);

const LivingRoomPanelCnt = () => (
  <>
    <div className="flex items-end pb-2 justify-between">
      <Link
        to="/living-room-furniture"
        className={classNames(
          'text-2xl font-bold !text-gray block pt-6 px-6 pb-0',
          'hover:!no-underline',
          'md:max-[1023px]:pl-0 md:max-[1023px]:pt-0'
        )}
      >
        Living Room
      </Link>

      <CtaLink
        to="/customer-photos/?room=Living%20Room"
        color="brand"
        noLinkPadding
        className="hover:!text-brand hover:!no-underline"
      >
        Get Living Room Inspiration
      </CtaLink>
    </div>

    <TwoColumns
      column1={
        <div>
          <ShopPageList
            name="Sofas & Sectionals"
            path="/sofas-and-sectionals/"
            subcategories={getSubcategories('Sofas & Sectionals')}
            variant="LivingRoom"
          />

          <ShopPageList
            name="Tables"
            path="/all-tables/"
            subcategories={getSubcategories('Tables')}
            variant="LivingRoom"
          />
        </div>
      }
      column2={
        <div>
          <ShopPageList
            name="Chairs"
            path="/chairs/"
            subcategories={getSubcategories('Chairs')}
            variant="LivingRoom"
          />

          <ShopPageList
            name="Storage"
            path="/all-storage/"
            subcategories={getSubcategories('Storage')}
            variant="LivingRoom"
          />
        </div>
      }
    />
  </>
);

const LivingRoomPanelContent = withRouter(LivingRoomPanelCnt);

const LivingRoomPanelTablet = () => (
  <div className="[grid-area:ShopPageCategoryPanelLivingRoom]">
    <LivingRoomPanelContent />
  </div>
);

const LivingRoomPanelDesktop = () => (
  <ShopPageCategoryPanel
    name="Living Room"
    path="/living-room-furniture"
    inspirationPath="/customer-photos?room=Living Room"
    subcategories={mobileLivingRoomData.subcategory}
    className="[grid-area:ShopPageCategoryPanelLivingRoom] lg:mb-6"
    customPanelContent={<LivingRoomPanelContent />}
  />
);

export {
  DiningRoomPanel,
  DecorPanel,
  BedroomPanel,
  OutdoorPanel,
  LivingRoomPanelMobile,
  LivingRoomPanelTablet,
  LivingRoomPanelDesktop,
};
